<template>
  <div class="mainpage">
    <h2>serial numbers</h2>

    <div v-if="toPrint.length">
      <printing :toPrint="toPrint" v-on:close="toPrint=[]; reloadTable()"></printing>
    </div>
    <div v-else-if="toReport.cnt">
      <reporting :toReport="toReport" v-on:close="toReport=[];"></reporting>
    </div>
    <div v-else>

      <div class="home">
        <h3>Create New Serial Numbers</h3>
        <div class="form allowwrap">
          <div style="flex: 0 0">
            Prefix<br>
            <select class="sel" v-model="prefix" v-if="prefixes" @change="reloadMaxSuffix">
              <option></option>
              <option v-for="i in prefixes">{{ i.p }}</option>
            </select>
          </div>
          <div style="min-width: 80px; flex: 0 0">
            First&nbsp;SN<br>
            <input type="text" placeholder="" v-model="maxSuffix" class="inp" v-on:input="validateMaxSuffix"
                   :class="{ 'muted': serverMaxSuffix == maxSuffix, 'inputerror': !maxSuffixValid }"/>
          </div>
          <div>
            Item&nbsp;Code<br>
            <input type="text" placeholder="please enter Item Code" v-model="modelNumber"
                   v-on:keyup.enter="onModelEnterKey" class="inp" :class="{'validValue': validModel}"/>
          </div>
          <div>
            Production&nbsp;Order<br>
            <input type="text" v-model="productionOrder" placeholder="please scan PO code"
                   :class="{'validValue': validProductionOrder }" class="inp"/>
            <div v-if="!validProductionOrder && productionOrder.length>0" class="error">PO number is not valid!</div>
          </div>
          <div style="flex: 0 0">
            Count<br>
            <input style="width:4em" type="number" min="1" v-model="xcount" class="inp c"/>
          </div>
          <button class="inp defcolor" style="margin: 10px 2px; width: 99px" :disabled="!validData"
                  @click="createSerials">
            <plus-icon/>
            Create
          </button>
        </div>
        <div v-if="listModelNumbers" class="modellist">
          <hr/>
          <h4>Available Item Codes:</h4>
          <ul>
            <li v-for="m in listModelNumbers" @click="setModel(m.itemCode)"><span class="code"
                                                                                  :class="{'selected': m.itemCode==modelNumber}">{{
                m.itemCode
              }}</span>
              {{ m.itemDescr }}
            </li>
          </ul>
          <p v-if="listModelNumbers.length>49">... there's more items - make your Item Code more specific...</p>
        </div>
      </div>

      <div class="home">
        <h3>Search for Serial Numbers</h3>
        <div class="flt">
          <label><input type="checkbox" v-model="srch.notPrinted" value="1"> only not printed yet </label> &nbsp;
          <label><input type="checkbox" v-model="srch.notProduced" value="1"> not produced </label>&nbsp;&nbsp;
          <label><input type="checkbox" v-model="srch.notShipped" value="1"> not shipped </label>&nbsp;&nbsp;
          <div style="width:150px; margin-left: 20px">
            <button class="inp" @click="showDates=!showDates">
              <calclock-icon/>&nbsp;<span v-if="showDates">hide</span><span v-else>show</span> date filters
            </button>
          </div>
        </div>
        <div class="form allowwrap">
          <div>
            Serial&nbsp;Number<br>
            <input type="text" v-model="srch.serialNumber" placeholder="Serial Number" class="inp"
                   @keypress.enter="applyFilter"/>
          </div>
          <div>
            Item&nbsp;Code<br>
            <input type="text" placeholder="Item Code" v-model="srch.itemCode" class="inp"
                   @keypress.enter="applyFilter"/>
          </div>
          <div>
            Production&nbsp;Order No<br>
            <input type="text" v-model="srch.productionNumber" placeholder="Production Number" class="inp"
                   @keypress.enter="applyFilter"/>
          </div>
          <div>
            Sales&nbsp;Order&nbsp;No<br>
            <input type="text" v-model="srch.salesNumber" placeholder="Sales Number" class="inp"
                   @keypress.enter="applyFilter"/>
          </div>
        </div>
        <div v-if="showDates" class="form allowwrap">
          <div>
            Date <b>created</b> from:<br>
            <input type="date" v-model="srch.cr_from" class="inp s"/>
            to:<br>
            <input type="date" v-model="srch.cr_to" class="inp s"/>
          </div>
          <div>
            Date <b>printed</b> from:<br>
            <input type="date" v-model="srch.pr_from" class="inp s"/>
            to:<br>
            <input type="date" v-model="srch.pr_to" class="inp s"/>
          </div>
          <div>
            Date <b>produced</b> from:<br>
            <input type="date" v-model="srch.po_from" class="inp s"/>
            to:<br>
            <input type="date" v-model="srch.po_to" class="inp s"/>
          </div>
          <div>
            Date <b>shipped</b> from:<br>
            <input type="date" v-model="srch.sh_from" class="inp s"/>
            to:<br>
            <input type="date" v-model="srch.sh_to" class="inp s"/>
          </div>
        </div>
        <div class="form2">
          <div style="width:100px;">
            <button class="inp" @click="clearFilter">
              <close-icon/>
              clear all
            </button>
          </div>
          &nbsp;&nbsp;&nbsp;
          <div style="width:200px;">
            <button class="inp defcolor" @click="applyFilter">
              <magnify-icon/>
              SEARCH
            </button>
          </div>
        </div>
      </div>

      <div v-if="searchResult && !toPrint.length" class="searchResult">
        <div v-if="multipleSelection" class="buttons">
          <button class="inp" :class="{'defcolor': selrowToPrint }" @click="printSelection">
            <printer-icon fillColor="#FFF"/>
            Print barcodes
          </button>
          <button class="inp" :class="{'defcolor': searchResult.rows.length }" @click="reportSelection">
            <file-chart-icon fillColor="#FFF"/>
            Report all rows
          </button>
          <button class="inp" :class="{'defcolor': multipleSelection.length }" @click="commentSelection">
            <comment-icon fillColor="#FFF"/>
            Comment
          </button>
          <button class="inp" :class="{'defcolor': !showMoreButtons }" @click="showMoreButtons=!showMoreButtons">
            <chevron-double-down fillColor="#FFF"/>
            Other Tools...
          </button>
        </div>
        <transition name="slide">
          <div v-if="multipleSelection && showMoreButtons" class="buttons">
            <button class="inp" :class="{'defcolor': multipleSelection.length }" @click="inactiveSelection">
              <eye-off-icon fillColor="#FFF"/>
              Deactivate
            </button>
            <button class="inp" :class="{'defcolor': multipleSelection.length }" @click="updProdOrdSelection">
              <edit-icon fillColor="#FFF"/>
              Corr. Prod.Order
            </button>
            <button class="inp" :class="{'defcolor': selrowToManu }" @click="manufactureSelection">
              <hammer-icon fillColor="#FFF"/>
              Clear Produced
            </button>
            <button class="inp" :class="{'defcolor': selrowToShip }" @click="shipSelection">
              <truck-icon fillColor="#FFF"/>
              Clear Shipped
            </button>

          </div>
        </transition>
        <transition name="slide">
          <div v-if="toComment.length" style="text-align: right; margin: 5px ">
            <textarea class="ta" rows="3" v-model="commentfield"></textarea>
            <button class="inp" style="width: 200px;" :class="{'defcolor': commentfield.length }" @click="saveComment">
              <check-icon fillColor="#FFF"/>
              Save comment
            </button>
          </div>
          <div v-if="toUpdProdOrd.length" style="text-align: right; margin: 5px">
            <input type="text" v-model="newProdOrder" class="inp" style="width: 250px"> &nbsp;
            <button class="inp" style="width: 200px;" :class="{'defcolor': newProdOrder.length>2 }"
                    @click="updateProdOrder">
              <check-icon fillColor="#FFF"/>
              Update Prod. Order
            </button>
          </div>
        </transition>

        <data-tables
            :data="searchResult.rows"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            :page-size="100"
            :pagination-props="{ pageSizes: [20,50,100,200,500,1000] }">
          >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="serNumber" label="Serial Number" sortable="custom"></el-table-column>
          <el-table-column label="Item Code" prop="itemCode" sortable="custom"></el-table-column>
          <el-table-column label="Created Date" prop="createdDT" sortable="custom"></el-table-column>
          <el-table-column label="Printed Date" prop="printedDT" sortable="custom"></el-table-column>
          <el-table-column label="Production Order" prop="prodOrderNum" sortable="custom"></el-table-column>
          <el-table-column label="Production Date" prop="producedDT" sortable="custom"></el-table-column>
          <el-table-column label="Sales Order" prop="salesOrderNum" sortable="custom"></el-table-column>
          <el-table-column label="Shipped Date" prop="shippedDT" sortable="custom"></el-table-column>
          <el-table-column label="Comment" prop="comment" sortable="custom"></el-table-column>

        </data-tables>
        <!-- <vue-good-table ref="resultTable" styleClass="vgt-table condensed striped bordered"
                        :columns="searchResult.columns"
                        :rows="searchResult.rows"
                        :search-options="{ enabled: false,  placeholder: 'Search within results' }"
                        :pagination-options="{ enabled: true, mode: 'pages', perPage: 50, perPageDropdown: [20, 50, 100, 500, 1000]}"
                        :selectOptions="{ enabled: true, selectionInfoClass: 'custom-class', selectionText: 'rows selected', clearSelectionText: 'clear' }"
                        @on-selected-rows-change="selectionChanged">
           <div slot="selected-row-actions">
                <button class="inp" :class="{'defcolor': selrowToPrint }" @click="printSelection"><printer-icon fillColor="#FFF"  /> Print barcodes</button>
                <button class="inp" :class="{'defcolor': selrowToManu }" @click="manufactureSelection"><hammer-icon fillColor="#FFF"/> Clear Manufactured</button>
                <button class="inp" :class="{'defcolor': selrowToShip }" @click="shipSelection"><truck-icon fillColor="#FFF"/> Clear Shipped</button>
            </div> -->
      </div>
    </div>

    <div class="overlay" v-if="loading || computing "></div>
    <div class="loading" v-if="loading || computing">
      <sync-icon style="font-size: 80px; color: white"/>
    </div>
  </div>
</template>

<script>
import debounce from '@/debounce';
import {mapState, mapGetters} from 'vuex'
import PrinterIcon from "vue-material-design-icons/printer.vue"
import HammerIcon from "vue-material-design-icons/hammer.vue"
import TruckIcon from "vue-material-design-icons/truck-delivery.vue"
import MagnifyIcon from "vue-material-design-icons/magnify.vue"
import CloseIcon from "vue-material-design-icons/close.vue"
import CalclockIcon from "vue-material-design-icons/calendar-clock.vue"
import PlusIcon from "vue-material-design-icons/plus-box-outline"
import SyncIcon from "vue-material-design-icons/sync"
import FileChartIcon from "vue-material-design-icons/file-chart"
import CommentIcon from "vue-material-design-icons/comment-text"
import CheckIcon from "vue-material-design-icons/check"
import EyeOffIcon from "vue-material-design-icons/eye-off"
import EditIcon from "vue-material-design-icons/lead-pencil"
import ChevronDoubleDown from "vue-material-design-icons/chevron-double-down"


import Vue from 'vue'
// set language to EN
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

locale.use(lang)
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)
import VueDataTables from 'vue-data-tables'

Vue.use(VueDataTables)

import Printing from "@/components/Printing.vue"
import Reporting from "@/components/Reporting.vue"

export default {
  name: 'home',
  components: {
    'printing': Printing,
    'reporting': Reporting,
    PrinterIcon,
    HammerIcon,
    TruckIcon,
    MagnifyIcon,
    CloseIcon,
    CalclockIcon,
    PlusIcon,
    SyncIcon,
    FileChartIcon,
    CommentIcon,
    CheckIcon,
    EyeOffIcon,
    EditIcon,
    ChevronDoubleDown
  },
  data() {
    return {
      maxSuffix: null,
      maxSuffixValid: true,
      index: null,
      computing: false,
      prefix: '', //defaultni
      modelNumber: '',
      xcount: 1,
      commentfield: '',
      productionOrder: '',
      toComment: [],
      toUpdProdOrd: [],
      showDates: false,
      templ_start: [, {x: 1, y: 1}, {x: 1, y: 1}],
      srch: {
        notProduced: false,
        notShipped: false,
        itemCode: '',
        serialNumber: '',
        productionNumber: '',
        salesNumber: '',
        notPrinted: false,
        cr_from: null,
        cr_to: null,
        po_from: null,
        po_to: null,
        pr_from: null,
        pr_to: null,
        sh_from: null,
        sh_to: null,
      },
      toPrint: [],
      toReport: {cnt: 0, items: []},
      selrowToPrint: 0,
      selrowToManu: 0,
      selrowToShip: 0,
      multipleSelection: [],
      newProdOrder: '',
      showMoreButtons: false
    }
  },
  computed: {
    ...mapState(['listModelNumbers', 'loading', 'lastResult', 'searchResult', 'serverMaxSuffix']),
    ...mapGetters(['prefixes']),
    validProductionOrder() {
      return this.productionOrder.match(/^.{4,}$/i);
    },
    validModel() {
      if (this.listModelNumbers && this.listModelNumbers[0].itemCode == this.modelNumber)
        return true;
      else
        return false;
    },
    validData() {
      return this.validProductionOrder && this.xcount > 0 && this.validModel && this.maxSuffixValid;
    },
  },
  watch: {
    // prefixes: function () {
    //   if (!this.prefix)
    //     this.prefix = this.prefixes[0].p;
    // },
    serverMaxSuffix: function (n) {
      this.maxSuffix = n;
    },
    modelNumber: debounce(function () {
      this.$store.dispatch('checkModelNumber', this.modelNumber);
    }, 400),

    lastResult: function () {
      this.$toasted.show(this.lastResult.msg, {
        theme: "toasted-primary",
        position: "top-center",
        fullWidth: true,
        duration: 5000,
        type: this.lastResult.type
      });
    }

  },
  mounted() {
    this.$store.dispatch('getPrefix');
  },
  methods: {
    validateMaxSuffix($event) {
        if (this.maxSuffix.match(/^[0-9]*$/g))
            this.maxSuffixValid= true;
        else
          this.maxSuffixValid=false;
    },
    reloadMaxSuffix() {
      this.$store.dispatch('getMaxSuffix', this.prefix);
    },
    saveComment() {
      this.$store.dispatch('saveComment', {ids: this.toComment.map(a => a.snID), comment: this.commentfield});
      this.toComment = [];
      this.commentfield = '';
    },
    updateProdOrder() {
      this.$store.dispatch('updateProdOrder', {
        ids: this.toUpdProdOrd.map(a => a.snID),
        newProdOrder: this.newProdOrder
      });
      this.toUpdProdOrd = [];
      this.newProdOrder = '';
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;

      this.selrowToPrint = 0;
      this.selrowToManu = 0;
      this.selrowToShip = 0;

      for (var r in this.multipleSelection) {
        if (!this.multipleSelection[r].printedDT)
          this.selrowToPrint++;

        if (this.multipleSelection[r].producedDT && !this.multipleSelection[r].shippedDT)
          this.selrowToManu++;

        if (this.multipleSelection[r].shippedDT)
          this.selrowToShip++;

      }
    },
    reloadTable() {
      this.$store.dispatch('searchSerials', this.srch);

    },
    reportSelection() {
      this.computing = true;
      this.toReport.items = {};
      this.toReport.cnt = 0;
      for (var i in this.searchResult.rows) {
        var j = this.searchResult.rows[i];
        if (!this.toReport.items[j.itemCode]) this.toReport.items[j.itemCode] = {};
        if (!this.toReport.items[j.itemCode][j.prodOrderNum])
          this.toReport.items[j.itemCode][j.prodOrderNum] = {};
        if (!this.toReport.items[j.itemCode][j.prodOrderNum][j.producedDT])
          this.toReport.items[j.itemCode][j.prodOrderNum][j.producedDT] = [];
        this.toReport.items[j.itemCode] [j.prodOrderNum][j.producedDT]
            .push(j.serNumber);
        this.toReport.cnt++;
      }
      this.computing = false;
    },
    commentSelection() {
      if (this.toComment.length)
        this.toComment = [];
      else
        this.toComment = this.multipleSelection;
    },
    updProdOrdSelection() {

      if (this.toUpdProdOrd.length)
        this.toUpdProdOrd = [];
      else
        this.toUpdProdOrd = this.multipleSelection;
    },
    printSelection() {
      this.toPrint = this.multipleSelection;
      //this.$store.dispatch('printSerials',ids);
    },
    inactiveSelection() {
      this.$store.dispatch('deactivate', {ids: this.multipleSelection.map(a => a.snID), filter: this.srch});
    },
    manufactureSelection() {
      this.$store.dispatch('clearManufactured', {ids: this.multipleSelection.map(a => a.snID), filter: this.srch});
    },
    shipSelection() {
      this.$store.dispatch('clearShipped', {ids: this.multipleSelection.map(a => a.snID), filter: this.srch});
    },
    clearFilter() {
      this.srch.modelNumber = '';
      this.srch.serialNumber = '';
      this.srch.productionNumber = '';
      this.srch.salesNumber = '';
      this.srch.cr_from = null;
      this.srch.cr_to = null;
      this.srch.po_from = null;
      this.srch.po_to = null;
      this.srch.pr_from = null;
      this.srch.pr_to = null;
      this.srch.sh_from = null;
      this.srch.sh_to = null;
      this.$store.commit('setSearchResult', null);
    },
    applyFilter() {
      this.$store.dispatch('searchSerials', this.srch);
    },
    createSerials() {
      let data = {
        'prefix': this.prefix, 'modelNumber': this.modelNumber,
        'productionOrder': this.productionOrder, 'count': this.xcount
      };
      if (this.maxSuffix != this.serverMaxSuffix)
        data.firstSN = this.maxSuffix;
      this.$store.dispatch('createNewSerials', data);
      this.modelNumber = '';
    },
    onModelEnterKey() {
      if (this.listModelNumbers && this.listModelNumbers.length == 1) {
        this.setModel(this.listModelNumbers[0].itemCode);
      }
    },
    setModel(m) {
      this.modelNumber = m;
    }
  }

}
</script>

<style scoped>
.muted {
  color: #AAAAAA;
}

.form2 {
  display: flex;
  justify-content: flex-end;
}

.allowwrap {
  flex-wrap: wrap;
  align-items: end;
}

.r {
  text-align: right
}

h4 {
  margin: 10px 0;
  font-size: 14px
}

h3 {
  margin: 0 0 10px 0
}

h3, h4 {
  font-family: Verdana, sans-serif
}

.form .error {
  font-size: 12px;
  color: orange;
}

.form > DIV {
  margin: 5px 7px 5px 0;
  flex-grow: 1
}

.form > DIV:last-child {
  margin-right: 0
}

select.sel {
  -webkit-appearance: button;
  -webkit-padding-end: 20px;
  -webkit-padding-start: 2px;
  -webkit-user-select: none;
  border: 1px solid #AAA;
  border-radius: 5px;
  color: #333;
  font-size: inherit;
  margin: 5px 0;
  padding: 5px;
  width: 80px;
  background-color: white;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
}

.modellist LI {
  padding: 3px;
  cursor: pointer;
}

.modellist .code {
  padding: 2px 4px;
  background-color: #999;
  font-weight: bold;
  font-size: 12px;
  color: white;
  border-radius: 3px
}

.modellist .selected {
  background-color: green
}

.modellist UL {
  padding-left: 25px;
  font-size: 11px
}

.templates {
  display: flex;
  justify-content: stretch;
  clear: both
}

.templates > DIV {
  background: white;
  border: 1px solid #AAA;
  border-radius: 5px;
  flex: 1 1;
  margin: 10px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between
}

.flt {
  float: right;
  margin-top: -20px;
  display: flex;
  align-items: center;
}

@media only screen and (max-width: 650px) {
  .flt {
    float: none;
    margin: 6px 0;
    justify-content: space-between
  }
}

.buttons {
  display: flex;
  justify-content: center;
  margin: 10px 0
}

.buttons button {
  flex: 0 1 200px;
  margin: 0 5px
}

.ta {
  width: 100%;
  border: solid 1px #ccc;
  box-sizing: border-box;
  font-size: 14px;
  padding: 3px;
  border-radius: 5px
}

.slide-enter-active, .slide-leave-active {
  transition: opacity .5s;
}

.slide-enter, .slide-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}
.inputerror {
  border: solid 1px red;
  color: red;
}
</style>